import { render, staticRenderFns } from "./ItemsRelocationRep.vue?vue&type=template&id=2d5bd6ce&"
import script from "./ItemsRelocationRep.vue?vue&type=script&lang=js&"
export * from "./ItemsRelocationRep.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRelocationRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports